/**
 * Type guards for Bitrix24 API responses
 */

/**
 * Bitrix24 authentication data interface
 */
export interface B24AuthData {
  member_id?: string | number;
  domain?: string;
  access_token?: string;
  [key: string]: unknown;
}

/**
 * Type guard for B24AuthData
 * @param data - Data to check
 * @returns True if data is B24AuthData
 */
export function isB24AuthData(data: unknown): data is B24AuthData {
  if (typeof data !== 'object' || data === null) return false;
  const authData = data as Record<string, unknown>;
  return typeof authData.member_id === 'string' || typeof authData.member_id === 'number';
}

/**
 * Bitrix24 user.current API response interface
 */
export interface UserCurrentResponse {
  result?: {
    ID?: string | number;
    EMAIL?: string;
    NAME?: string;
    LAST_NAME?: string;
    LANGUAGE_ID?: string;
  };
  ID?: string | number;
  EMAIL?: string;
  NAME?: string;
  LAST_NAME?: string;
  LANGUAGE_ID?: string;
}

/**
 * Type guard for UserCurrentResponse
 * @param data - Data to check
 * @returns True if data is UserCurrentResponse
 */
export function isUserCurrentResponse(data: unknown): data is UserCurrentResponse {
  if (typeof data !== 'object' || data === null) return false;
  const response = data as Record<string, unknown>;

  // Check if has direct EMAIL or nested result.EMAIL
  if (typeof response.EMAIL === 'string') return true;
  if (typeof response.result === 'object' && response.result !== null) {
    const result = response.result as Record<string, unknown>;
    return typeof result.EMAIL === 'string';
  }

  return false;
}
